import LiveBackground, { useLiveBackground } from "../../liveBackground/LiveBackground";
import {getPostNum} from "../../../constant/General";
import {getDateTime} from "../../../utility/dateUtils";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {configSc, drawingV2} from "../../../constant/initDrawing";
import Welcome from "../Welcome";
import Loading from "../../results/loading";
import Random from "../../results/random";
import loading from "../../../assets/images/live-v2/gif/loading.gif";
import LayoutWrapper from "../mt/LayoutWrapper";
import ContentWrapper from "../mt/ContentWrapper";

const config = configSc;

const RenderResult = ({num}) => {
    if (num.includes("*")) {
        return <span style={configSc.style.center}><Loading sizeDigit={num.length} style={{width: "80px"}}
                                                            src={loading}/></span>
    } else if (num.includes("?")) {
        return <span style={configSc.style.random}><Random sizeDigit={num.length} className="draw-style-sc2"/></span>
    } else return <span
        style={configSc.style.drawing}>{num}</span>
};

const Live2Sc = ({socket}) => {
    const navigate = useNavigate();
    const backgroundType = useLiveBackground();
    const [result, setResult] = useState(drawingV2);

    useEffect(() => {
        socket.on("sc_result", (draw) => {
            setResult(draw);
        });

        return () => {
            socket.off("sc_result");
        }
    }, [socket]);

    const onStartDraw = (result) => {
        setResult(result)
    }

    if (result.results.length === 0) return <Welcome onStartDraw={onStartDraw}/>

    return <LiveBackground result={result} className="d-flex justify-content-center overflow-hidden mt-2 live2-sc">
        <button
            type="button"
            className="welcome-back-button"
            onClick={() => navigate(backgroundType ? "/live-full" : "/")}
        >
            Back
        </button>
        <div>
            <div className="live-draw-heading d-flex justify-content-center align-items-center mb-3 f-20 text-info">
                <span className="mr-4 fw-bold f-26">
                    SC
                </span> {getDateTime(result?.drawAt)}</div>

            <LayoutWrapper>
                <ContentWrapper>
                    <div className="d-flex position-relative" style={{
                        ...config.style.wrapper,
                        ...(backgroundType ? { backgroundImage: "none" } : {}),
                    }}>
                        <div style={config.style.container}>
                            <div style={{height: "700px", position: "relative"}}>
                                <div style={{paddingLeft: "90px"}} className="d-flex justify-content-center">
                                    <div>
                                        {
                                            result.results.map((num, i) => {
                                                return <div style={{
                                                    height: "118px", marginBottom: "28px", fontSize: "96px"
                                                }}
                                                            className="d-flex justify-content-center align-items-center"
                                                            key={i}>
                                                    <RenderResult num={num.number}/>
                                                </div>
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div style={config.style.container2}
                             className="d-flex justify-content-center align-items-center">
                            <div style={{height: "718px", position: "relative"}}>
                                <div style={{paddingLeft: "165px"}}
                                     className="d-flex justify-content-center align-items-center">
                                    <div>
                                        {
                                            result.results.map((num, i) => {
                                                return <div
                                                    style={{
                                                        height: "135px",
                                                        marginBottom: "10px",
                                                        color: "#FFFFFF",
                                                        fontSize: "150px"
                                                    }}
                                                    className="d-flex justify-content-center align-items-center"
                                                    key={i}>
                                                    <div className="d-flex justify-content-center align-items-center"
                                                         style={{
                                                             marginRight: "118px"
                                                         }}>{getPostNum(num.number.slice(0, 2))}</div>
                                                    <div
                                                        className="d-flex justify-content-center align-items-center">{getPostNum(num.number.slice(2, 5))}</div>
                                                </div>
                                            })
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ContentWrapper>
            </LayoutWrapper>
        </div>
    </LiveBackground>
}

export default Live2Sc;
